<drawer
  [title]="determinant != null && determinant.id != null ? 'Edit Determinant' : 'Add Determinant'"
  [isClosed]="isClosed"
  [embedded]="isEmbedded"
  [hideCancel]="false"
  [hideSave]="false"
  [hideDelete]="determinant != null && determinant.id != null ? false : true"
  [showHeaderButtons]="true"
  [loading]="loading"
  [noContentPadding]="noContentPadding"
  [forcePadding]="forcePadding"
  (deleteEvent)="deleteDeterminant()"
  (saveEvent)="save()"
  (closeEvent)="cancel()"
  (cancelEvent)="cancel()">
  <div class="drawer-content drawer-direct-content">
    <form name="itemForm" class="form-validation container-fluid mt-4">
      <div class="row pb-3 {{ stickyScrolling ? 'm-0' : '' }}">
        <div class="col-12">
          <div class="row fields-group py-0">
            <div class="col-12 col-md-6">
              <div class="form-group form-group--narrow mb-3">
                <div class="row">
                  <div class="col-12 col-12">
                    <label class="input-label field-required"> {{
                      'dets.label' | translate }} </label> <input
                      class="form-control" type="text" name="name"
                      [(ngModel)]="name" #detName="ngModel"
                      [rangeLength]="[2, 256]" required autofocus />
                  </div>
                </div>
                <p class="validation-error"
                  *ngIf="detName.errors && detName.errors.required && (detName.dirty && detName.touched)">
                  {{ 'form.validate.required' | translate }}</p>
                <p class="validation-error"
                  *ngIf="detName.errors && detName.errors.rangeLength && (detName.dirty && detName.touched)">
                  {{ 'form.validate.minLenght' | translate }} 2!</p>
                <p class="validation-error"
                  *ngIf="detName.errors && detName.errors.rangeLength && (detName.dirty && detName.touched)">
                  {{ 'form.validate.maxLenght' | translate }} 256!</p>
              </div>
            </div>
          </div>

          <!-- Hide, maybe remove Determinant Type from new Event determinant -->
          <div class="row row-content fields-group py-0 d-none">
            <div class="col-12">
              <div class="form-group form-group--narrow mb-3">
                <div class="row">
                  <div class="col-12">
                    <label class="input-label">{{ 'Determinant type' | translate }}</label>
                    <select #selectElem
                      name="determinantType" [(ngModel)]="determinantType"
                      (change)="determinantTypeChanged(determinantType)"
                      class="form-control"
                      *ngIf="determinant == null || determinant.id == null || determinantType == null">
                      <option value="" selected disabled>{{
                        'Choose here' | translate }}</option>
                      <option value="FORMFIELD">{{ 'Field value determinant' | translate }}</option>
                      <option value="REGISTRATION">{{ 'Registration' | translate }}</option>
                      <option value="COLLECTION_PLACE">{{ 'Collection place' | translate }}</option>
                      <option value="BOT">{{ 'External service determinant' | translate }}</option>
                    </select>
                    <div
                      *ngIf="determinant != null && determinant.id != null"
                      class="ml-3 badge badge-secondary mr-2">{{
                      determinantType }}</div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group--narrow"
                [ngClass]="{ 'form-group--blue': true }"
                *ngIf="determinantType == 'REGISTRATION'">
                <registrationselection class="mb-3 d-block"
                  [items]="registrations" [selectedItem]="registration"
                  (isSelected)="selectRegistration($event)"></registrationselection>
                <boolean-determinant class="mb-3 d-block"
                  (booleanValueResponse)="booleanValueChanged($event)"
                  [booleanValue]="booleanValue"> </boolean-determinant>
              </div>

              <div class="form-group form-group--narrow"
                [ngClass]="{ 'form-group--blue': true }"
                *ngIf="determinantType == 'COLLECTION_PLACE'">
                <select-collection-place class="mb-3 d-block"
                  [items]="registrationServiceLocations"
                  [selectedItem]="registrationLocation"
                  (isSelected)="selectRegistrationLocation($event)"></select-collection-place>
                <boolean-determinant class="mb-3 d-block"
                  (booleanValueResponse)="booleanValueChanged($event)"
                  [booleanValue]="booleanValue"> </boolean-determinant>
              </div>

            </div>

          </div>
          <formfield-determinant *ngIf="determinantType == 'FORMFIELD'"
            [serviceId]="serviceId" [determinant]="determinant" [name]="name"
            (determinantResponse)="formFieldDeterminantChanged($event)"></formfield-determinant>
        </div>
      </div>

      <bot-determinant class="mb-3 d-inline-block"
        *ngIf="determinantType == 'BOT'" [determinant]="determinant"
        (determinantChangedEvent)="updateDeterminant($event)"
        [stickyScrolling]="stickyScrolling"> </bot-determinant>

      <div *ngIf="determinant?.id" class="row fields-group">
        <div class="col d-flex flex-column">
          <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1" (click)="determinant?.usages?.length > 0 ? showUsages = !showUsages : false" [ngClass]="{'expanded': showUsages}">
            <div class="col justify-content-between d-flex">
              <label class="input-label mb-0">
                {{ 'Usages' | translate }} <span class="badge badge-light ml-2">{{ determinant.usages.length }}</span>
               </label>
               <i *ngIf="determinant?.usages?.length > 0" class="fas ml-auto mt-1" [ngClass]="{'fa-chevron-down': !showUsages, 'fa-chevron-up': showUsages}" aria-hidden="true"></i>
            </div>
          </div>
          <div *ngIf="determinant?.usages?.length > 0" class="row fields-group-content flex-grow-1">
            <div class="col">
              <ng-container *ngFor="let usage of determinant.usages">
                <div class="usage-item mb-2 p-2">
                  <div class="d-flex align-items-center">
                    <span class="badge badge-{{formatUsageType(usage.type)}} mr-2">{{ usage.type | translate }}</span><strong>{{ usage.name }}</strong><span class="badge badge-light ml-2">(ID: {{ usage.entityId }})</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="determinant?.id && determinant?.isDuplicate" class="row fields-group">
        <div class="col d-flex flex-column">
          <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1" (click)="determinant?.duplicateNames?.length > 0 ? showDuplicates = !showDuplicates : false" [ngClass]="{'expanded': showDuplicates}">
            <div class="col justify-content-between d-flex">
              <label class="input-label mb-0">
                {{ 'Duplicates' | translate }} <span class="badge badge-light ml-2">{{ determinant.duplicateNames.length }}</span>
               </label>
               <i *ngIf="determinant?.duplicateNames?.length > 0" class="fas ml-auto mt-1" [ngClass]="{'fa-chevron-down': !showDuplicates, 'fa-chevron-up': showDuplicates}" aria-hidden="true"></i>
            </div>
          </div>
          <div *ngIf="determinant?.duplicateNames?.length > 0" class="row fields-group-content flex-grow-1">
            <div class="col">
              <ng-container *ngFor="let duplicateName of determinant.duplicateNames">
                <div class="duplicate-item mb-2 p-2">
                  <div class="d-flex align-items-center">
                    <span class="badge badge-warning mr-2">{{'Determinant' | translate}}</span><strong>{{ duplicateName }}</strong>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</drawer>